var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMedal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/medal"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.8875 15.5867L12.0558 11.6725L8.98077 9.39165H12.8231L14 5.43668L15.1769 9.39165H19.0192L15.9356 11.6725L17.1038 15.5867L14 13.1571L10.8875 15.5867ZM6.5 28V18.0046C5.55 17.0596 4.8125 15.9532 4.2875 14.6854C3.7625 13.4176 3.5 12.0614 3.5 10.6167C3.5 7.65722 4.51826 5.1479 6.55479 3.08873C8.59134 1.02958 11.0731 0 14 0C16.9269 0 19.4087 1.02958 21.4452 3.08873C23.4817 5.1479 24.5 7.65722 24.5 10.6167C24.5 12.0614 24.2375 13.4176 23.7125 14.6854C23.1875 15.9532 22.45 17.0596 21.5 18.0046V28L14 25.725L6.5 28ZM14 19.7167C16.5 19.7167 18.625 18.8319 20.375 17.0625C22.125 15.293 23 13.1444 23 10.6167C23 8.08888 22.125 5.94027 20.375 4.17083C18.625 2.40139 16.5 1.51667 14 1.51667C11.5 1.51667 9.375 2.40139 7.625 4.17083C5.875 5.94027 5 8.08888 5 10.6167C5 13.1444 5.875 15.293 7.625 17.0625C9.375 18.8319 11.5 19.7167 14 19.7167ZM8 25.8504L14 24.15L20 25.8504V19.2821C19.1635 19.9043 18.2341 20.3851 17.212 20.7244C16.1899 21.0637 15.1192 21.2333 14 21.2333C12.8808 21.2333 11.8101 21.0637 10.788 20.7244C9.76588 20.3851 8.83655 19.9043 8 19.2821V25.8504Z",
    fill: "#1E1E1E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMedal);
export default __webpack_public_path__ + "static/media/icon-medal.86cd6c9065593c3932dc2d29465e7b21.svg";
export { ForwardRef as ReactComponent };